import fetch from '@/plugin/axios'

// 新增优惠券
export function getAdde (query) {
  return fetch({
    url: '/api/common/coupon/add',
    method: 'Post',
    data: query
  })
}

// 优惠券查询
export function getArrList (query) {
  return fetch({
    url: '/api/common/coupon/list',
    method: 'Post',
    data: query
  })
}

// 删除优惠券
export function getDel (id) {
  return fetch({
    url: `/api/common/coupon/${id}`,
    method: 'DELETE'
  })
}

// 优惠券详情
export function getInfoD (id) {
  return fetch({
    url: `/api/common/coupon/info/${id}`,
    method: 'GET'
  })
}

// 优惠券编辑
export function getArrEdit (query, id) {
  return fetch({
    url: `/api/common/coupon/${id}`,
    method: 'Post',
    data: query
  })
}

// 根据商品ID查询商品列表
export function getSpuArr (query) {
  return fetch({
    url: '/api/goods/spu/list',
    method: 'Post',
    data: query
  })
}

// 优惠券下架
export function getOut (id) {
  return fetch({
    url: `/api/common/coupon/out/${id}`,
    method: 'Post'
  })
}

// 上架发布
export function getPublish (id) {
  return fetch({
    url: `/api/common/coupon/publish/${id}`,
    method: 'Post'
  })
}

// 发放优惠券
export function getgair (id, query) {
  return fetch({
    url: `/api/common/coupon/send/${id}`,
    method: 'Post',
    data: query
  })
}
